module.exports = __webpack_public_path__ + "f7737cdb404b93d89b195227295a8a88.png";